<template>
  <v-banner color="white" single-line style="pa-1" elevation="3">
    <div class="d-flex">
      <v-btn @click="$emit('top')" icon><v-icon>mdi-chevron-double-up</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('up')" icon ><v-icon>mdi-chevron-up</v-icon></v-btn>
      <v-btn @click="$emit('down')" class="ml-3" icon><v-icon>mdi-chevron-down</v-icon></v-btn>
    </div>
  </v-banner>
</template>

<script>
export default {
  
}
</script>